/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$('.js-comment-reply, .js-comment-edit, .js-comment-delete').on('click', function(e) {
  e.preventDefault();
  $('.js-comment-edit-or-reply').slideUp().remove();
  $('.js-comment-cancel').remove();
  $('.js-comment-reply, .js-comment-edit, .js-comment-delete').show();
  var button = $(this);
  var comment_id = button.data('comment-id');

  var comment_form = $('form#new_comment').clone().css({borderTop:'1px solid transparent'}).addClass('js-comment-edit-or-reply');
  comment_form.append($('<input />', {type: 'hidden', name: 'comment[comment_id]', value: comment_id}));
  comment_form.hide();
  comment_form.insertBefore(button);

  if (button.hasClass('js-comment-edit')) { // if it's an edit - prepopulate the fields from the old comment and set form action
    comment_form.append($('<input name="_method" type="hidden" value="put" />'));
    comment_form[0].action = "".concat(comment_form[0].action, "/").concat(comment_id);
    var old_comment = $("#comment_" + comment_id);
    comment_form.find('.js-new-comment-title input')[0].value = old_comment.find('.js-old-comment-title')[0].innerText;

    var comment_body = '';
    old_comment.find('.js-old-comment-body').each(function(i, e) {
      return comment_body = comment_body + $(e).text() + '\n';
    });
    comment_form.find('.js-new-comment-body textarea').val(comment_body);

  } else if (button.hasClass('js-comment-delete')) {
    if (confirm('Are you sure?')) {
      comment_form.append($('<input name="_method" type="hidden" value="delete" />'));
      comment_form[0].action = "".concat(comment_form[0].action, "/").concat(comment_id);
      comment_form.insertBefore(button);
      comment_form.submit();
    }
    return;
  }

  comment_form.slideDown();
  button.siblings('a').hide();
  button.hide();
  return button.after(
    $('<a />', {text: 'Cancel', "class": 'db mt4 f6 js-comment-cancel'}).on('click', function(e) {
      e.preventDefault();
      $(this).remove();
      comment_form.slideUp();
      button.show();
      return button.siblings('a').show();
  })
  );
});
